import { Action, createReducer, on } from '@ngrx/store';
import { TermsAndConditions } from '../models/terms-and-conditions.model';
import * as actions from '../actions';

export const getTermsAndConditionsKey = 'getTermsAndConditions';

export interface TermsAndConditionsState {
  loadTermsAndConditionsResponse: TermsAndConditions;
  loaded: boolean;
}

export const initialState: TermsAndConditionsState = {
  loadTermsAndConditionsResponse: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadGetTermsAndConditionsSuccess, (state, action) => ({
    ...state,
    loadTermsAndConditionsResponse: action.response,
    loaded: true
  }))
);

export const getTermsAndConditionsResponse = (state: TermsAndConditionsState) => state.loadTermsAndConditionsResponse;

export const getTermsAndConditionsLoaded = (state: TermsAndConditionsState) => state.loaded;
